import { ReactElement } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { PAGE_ICONS, PAGE_ROUTES } from '../../_const';
import PageWithBreadcrumbs from '../../components/layouts/NEPageWithBreadcrumbs';
import ViewLayout from '../../components/layouts/ViewLayout';
import CommunityConnectUserContainer from './CommunityConnectUserContainer';

/**
 * Community Connect User - new non-employee creation workflow
 * @returns {ReactElement} New Community Connect User Non-Employee Form with help panel, breadcrumb navigation
 */
const CommunityConnectUserView = () => {
	return (
		<PageWithBreadcrumbs
			currentPageLabel={'New Community Connect User'}
			CurrentPageIcon={PAGE_ICONS.IDENTITY}
		>
			<ViewLayout
				title={'New Community Connect User'}
				help={{
					title: 'Create New Non-Employee: Community Connect User',
					contents: (
						<Stack direction={'column'} spacing={2}>
							<Typography>
								This workflow is designed for Community Connect
								site administrators who wish to register new
								Community Connect Users and request Epic
								(Bridges) application access through IMS.
							</Typography>
							<Typography>
								This is a more streamlined workflow than
								requesting a new Non-Employee (
								<a
									href={PAGE_ROUTES.LEGACY_HOME}
									rel='noopener noreferrer'
									target='_parent'
								>
									Request &gt; Add Non-Employee Account
								</a>
								) and makes several assumptions about you, the
								requestor, and the new non-employee account you
								are creating. Please do not use this form unless
								you are a Community Connect site administrator
								and you are requesting Epic (Bridges)
								application access for a new non-employee user.
							</Typography>
							<Typography>
								If the Community Connect User has already been
								registered with IMS and you are looking to
								request Epic (Bridges), please leave this page
								and navigate to the application request workflow
								(
								<a
									href='/index.html?redirect=/RequestFlow/RequesteeSearch'
									rel='noopener noreferrer'
									target='_parent'
								>
									Request &gt; Application Access &gt; App
									Request For Others
								</a>
								)
							</Typography>
							<Typography>
								For a more detailed usage guide, please refer to
								the{' '}
								<a
									href='https://infonet.upmc.com/infonet/ls/content/8932526666595017/add-non-employee-as-epiccare-link-user-pdf-1764799986'
									rel='noopener noreferrer'
									target='_blank'
								>
									Add a Non-Employee as a Community Connect
									User - Guide for Site Admins
								</a>{' '}
								tip-sheet on InfoNet.
							</Typography>
						</Stack>
					),
				}}
			>
				<CommunityConnectUserContainer />
			</ViewLayout>
		</PageWithBreadcrumbs>
	);
};

export default CommunityConnectUserView;
